/**
 * "EN VIVO" badge (F3-G): shown when the session is inside its access
 * window (same pure calculation as join, `joinWindowState`). Reusable in
 * the schedule's session cards and in the cohort tabs.
 */
import { type Component, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { joinWindowState, type SessionTimes } from "@space/shared";
import { useI18n } from "@/providers/i18n-provider";
import { useNow } from "../hooks/use-now";

export const EnVivoBadge: Component<{ times: SessionTimes; class?: string }> = (props) => {
  const { t } = useI18n();
  const now = useNow();
  const live = () => joinWindowState(now(), props.times).isLiveNow;
  return (
    <Show when={live()}>
      <span
        class={`inline-flex items-center gap-1 rounded-full bg-danger/15 px-2 py-0.5 text-xs font-bold text-danger ${props.class ?? ""}`}
        data-testid="en-vivo-badge"
      >
        <span class="h-1.5 w-1.5 rounded-full bg-danger motion-safe:animate-pulse" />
        {t(msg`LIVE`)}
      </span>
    </Show>
  );
};
